import { type Editor, Range } from 'slate';
import { type CodeSnippetElement } from '../../../types/aha-editor';
import {
  isInlineActive,
  unwrapInline,
  wrapInline,
} from '../../InlinePlugin/utils';

export const isCodeSnippetActive = (editor: Editor) =>
  isInlineActive(editor, 'code-snippet');

// Insert a code snippet block in the editor
export const wrapCodeSnippet = (editor: Editor, content: string) => {
  const { selection } = editor;
  const isCollapsed = selection && Range.isCollapsed(selection);

  const buildCodeSnippetElement = (): CodeSnippetElement => {
    return {
      type: 'code-snippet',
      children: isCollapsed ? [{ text: content }] : [],
    };
  };

  wrapInline(editor, buildCodeSnippetElement, false);
};

export const unwrapCodeSnippet = (editor: Editor) => {
  unwrapInline(editor, 'code-snippet');
};
